import { useAuth } from '../contexts/AuthContext';

export function useAdminGuard() {
  const { currentUser } = useAuth();
  const isAdmin = currentUser?.role?.role_name?.toLowerCase() === 'admin';
  return { isAdmin, currentUser };
}
